<!--
  - MyTh Ahmed Faiz Copyright © 2016-2022 All rights reserved.
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Website: https://www.4myth.com
  -->
<script>
import { MetaInfoMixin } from '@mixins'

export default {
  name: 'OrderNotesReport',
  mixins: [MetaInfoMixin],
  data () {
    const n = this.$moment().locale('en')
    return {
      loading: !1,
      form: {
        from_date: n.format('YYYY-MM-DD'),
        to_date: n.add(5, 'days').format('YYYY-MM-DD')
      },
      result: [],
      headers: [],
      total: 0,
      date_text: null
    }
  },
  mounted () {
    // this.loading = false
    // this.checkPermission('show')
    // this.initItem()
  },
  methods: {
    goBack () {
      this.$router.back()
    },
    async onSearch () {
      this.loading = true
      this.result = []
      this.headers = []
      this.total = 0
      this.date_text = null
      try {
        const { _data, _success } = await this.apiService.report.orderNote(this.form)
        this.headers = _data.headers || []
        if (_success) {
          this.loading = !1
          this.result = _data.result || []
          this.total = _data.total || 0
          this.date_text = _data.date_text || null
        }
      } catch (e) {
        const { _message } = e || {}
        _message && this.alertError()
      } finally {
        this.loading = false
      }
      console.log(this.form)
    },
    printReport () {
      window.print()
    }
  }
}
</script>

<template>
  <app-card :title="$t('reportsPage.order_note.title')">
    <v-skeleton-loader
      :loading="loading"
      type="table"
    >
      <v-container>
        <v-row class="d-print-none">
          <v-col cols="12">
            <div class="text-h6">
              {{ parseAttribute('date') }}
            </div>
          </v-col>
          <app-date-picker
            v-model="form.from_date"
            clearable
            cols="12"
            hide-details
            lg="4"
            name="from_date"
            sm="6"
          />
          <app-date-picker
            v-model="form.to_date"
            clearable
            cols="12"
            hide-details
            lg="4"
            name="to_date"
            sm="6"
          />
          <v-col>
            <app-btn
              :disabled="loading"
              :loading="loading"
              @click="onSearch"
            >
              {{ parseAttribute('do_search') }}
            </app-btn>
          </v-col>
          <v-col
            v-if="result.length"
            cols="auto"
          >
            <app-btn
              @click="printReport"
            >
              {{ parseAttribute('print') }}
            </app-btn>
          </v-col>
        </v-row>
        <v-row v-if="result.length > 0">
          <v-col cols="12">
            <div class="text-h6">
              <span
                v-if="!!date_text"
              >
                {{ date_text }}<br>
              </span>
              <span>
                {{ parseAttribute('reportsPage.order_note.report_total', { v: total }) }}
              </span>
            </div>
          </v-col>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="result"
              :items-per-page="-1"
              hide-default-footer
            />
          </v-col>
        </v-row>
      </v-container>
    </v-skeleton-loader>
    <template #afterTitle>
      <v-spacer />
      <app-btn @click="goBack">
        {{ parseAttribute('back') }}
      </app-btn>
    </template>
  </app-card>
</template>
